import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import PushOtpChallengeRequest from '../challenge-request/PushOtpChallengeRequest';
import { connect } from 'react-redux';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';

class PushOtpAuthAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faSignInAlt
  static authname = "Push OTP"
  static description = "Authenticate via Push OTP"
  static authLevel = 850

  static challengeRequestComponent = PushOtpChallengeRequest

  get enrolled(): boolean {
    return this.props.authmethods.pushOtp.enrolled
  }

  get required(): boolean {
    return this.props.challenge.requiredCredentials.pushOtp ? true : false
  }
}

const mapStateToProps = ({ authmethods, challenge }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(PushOtpAuthAuthButton)